import { render } from "./test.vue?vue&type=template&id=84eea390"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"
script.render = render

export default script